import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { useModalContext } from '../../../../ui/modal/contexts'
import { ThemeButton, FilterBox } from '../../../../ui'

import { GuildUsersCreateDialog } from '../dialog'

export const GuildUsersFilter = () => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useModalContext()

  const handleCreateGuildUser = () =>
    open({
      Component: GuildUsersCreateDialog,
      type: 'responsive',
      maxWidth: 'md',
    })

  return (
    <FilterBox>
      <Box ml={2}>
        <ThemeButton color="primary" labelM="sm" onClick={handleCreateGuildUser}>
          {formatMessage({ id: 'pages.guild.users.addButton.label' })}
        </ThemeButton>
      </Box>
    </FilterBox>
  )
}
